import React from 'react';
import CreatableSelect from 'react-select/creatable';
import Select from 'react-select'
import { customReactSelectStyles } from '../../utils/Helper';

//     control: (baseStyles, state) => ({
//         borderColor: state.isFocused ? '#9FA4A4' : '#9FA4A4',
//     noOptionsMessage: (provided) => ({
//     valueContainer: (provided, state) => ({
//     input: (provided, state) => ({
//     indicatorSeparator: (state) => ({
//     indicatorsContainer: (provided, state) => ({

const CreatableSelectComponent = ({
    label = null,
    id = null,
    placeholder,
    value,
    options,
    setOptions,
    setSelectedValue,
    isCreatable = true,
    classes = null,
    isDisabled = false,
    clearValue = () => {},
}) => {
    const handleCreate = (inputValue, setOptions) => {
        const newOption = { value: inputValue, label: inputValue };
        const optionFunction = (prevOptions) => {
            if (!Array.isArray(prevOptions)) {
                return [newOption];
            }
            return [...prevOptions, newOption];
        };
        setOptions(optionFunction());
        setSelectedValue(newOption)
    };

    const handleOnChange = (value) => {
        id && clearValue(id)
        setSelectedValue(value);
    }

    const filterOption = (option, inputValue) => option.label.toLowerCase().includes(inputValue.toLowerCase());
    const formatCreateLabel = (inputValue) => `Create Custom Value "${inputValue}"`;

    return (
        <div className={`${classes ? classes : ""}`}>
            {label && <label
                htmlFor={id}
                className="block mb-1 text-primary text-f14 font-semibold text-left"
            >
                {label}
            </label>}
            <div className={`${isDisabled ? "cursor-not-allowed" : "cursor-pointer"}`}>
            {isCreatable ? <CreatableSelect
                placeholder={placeholder}
                styles={customReactSelectStyles}
                className="text-left"
                onChange={handleOnChange}
                value={value}
                onCreateOption={(value) => handleCreate(value, setOptions)}
                isClearable
                options={options}
                formatCreateLabel={formatCreateLabel}
                filterOption={filterOption}
                theme={(theme) => ({
                    ...theme,
                    colors: {
                      ...theme.colors,
                      primary: '#9FA4A4',
                      primary25: '#FFA997'
                    },
                  })}
                isDisabled={isDisabled}
            /> : <Select
                placeholder={placeholder}
                styles={customReactSelectStyles}
                className="text-left"
                onChange={handleOnChange}
                value={value}
                onCreateOption={(value) => handleCreate(value, setOptions)}
                isClearable
                options={options}
                formatCreateLabel={formatCreateLabel}
                filterOption={filterOption}
                isDisabled={isDisabled}
                theme={(theme) => ({
                    ...theme,
                    colors: {
                      ...theme.colors,
                      primary: '#9FA4A4',
                      primary25: '#FFA997',
                    },
                  })}
            />}
            </div>
        </div>
    );
};

export default CreatableSelectComponent;
